import { Pipe, PipeTransform } from '@angular/core';

import { WarningStatusDetails, WarningStatusType } from '@dpr-details/enums';

@Pipe({ name: 'warningStatus' })
export class WarningStatusPipe implements PipeTransform {
  transform(
    warningStatus: WarningStatusType,
    dprLockedData: Date
  ): {
    text: string;
    icon: string;
    color: string;
  } {
    return warningStatus && !dprLockedData
      ? WarningStatusDetails.get(warningStatus)
      : { text: null, icon: 'check', color: 'success' };
  }
}
